import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SVGComponent(props) {
  return (
    <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M9.9999 8.139L16.9029 1.23587C17.4174 0.721383 18.2495 0.721375 18.764 1.23585C19.2787 1.75034 19.2787 2.58249 18.764 3.097C18.764 3.09701 18.764 3.09702 18.764 3.09703L11.8612 10.0001L18.764 16.9032C18.764 16.9032 18.764 16.9033 18.764 16.9033C19.2787 17.4178 19.2787 18.2499 18.764 18.7644C18.5073 19.021 18.1702 19.15 17.8334 19.15C17.4967 19.15 17.1595 19.021 16.9029 18.7644L9.9999 11.8613L3.09712 18.7644C2.8405 19.021 2.50335 19.15 2.16657 19.15C1.82988 19.15 1.4925 19.0211 1.23605 18.7644C0.721317 18.2499 0.721317 17.4177 1.23605 16.9032L8.1388 10.0001L1.23605 3.09703C1.23604 3.09702 1.23603 3.09701 1.23602 3.097C0.721325 2.5825 0.721325 1.75037 1.23603 1.23587L9.9999 8.139ZM9.9999 8.139L3.09712 1.23588L3.0971 1.23585C2.58242 0.721405 1.75055 0.721361 1.23605 1.23585L9.9999 8.139Z"
        fill="#FF4D4F"
        stroke="#FF4D4F"
        strokeWidth={0.3}
      />
    </Svg>
  );
}
export default SVGComponent;
